import {
  HiOutlineSquares2X2 as DashboardIcon,
  HiOutlineArrowTrendingUp as EscalationIcon,
  HiOutlineInbox as AllQueriesIcon,
  HiOutlineDocumentText as QueryDetailsIcon,
  HiOutlinePlusCircle as RaiseQueryIcon,
  HiOutlineClipboardDocumentList as AssignedQueriesIcon,
  HiOutlineCheckCircle as ClosedQueriesIcon,
  HiOutlineUsers as UsersIcon,
  HiOutlineShieldCheck as RolesIcon,
  HiOutlineChartBar as SLADashboardIcon,
  HiOutlineCog6Tooth as SettingsIcon,
  HiOutlineQuestionMarkCircle as HelpIconOutline,
  HiOutlineBriefcase as ProjectIcon,
} from 'react-icons/hi2';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { WebConfig } from '../web-config';

export const MOBILE_BREAKPOINT = 768;

export const SSO_LOGOUT_URL = `${WebConfig.REACT_APP_AAI_SSO_BASE_URL}`;

export const ROUTE_MAP = {
  '/dashboard': { title: 'Dashboard', icon: DashboardIcon },
  '/dashboard/admin': { title: 'Admin Dashboard', icon: DashboardIcon },
  '/dashboard/chairperson': { title: 'Chairperson Dashboard', icon: DashboardIcon },
  '/dashboard/responder': { title: 'Responder Dashboard', icon: DashboardIcon },
  '/dashboard/queries/all': { title: 'All Queries', icon: AllQueriesIcon },
  '/dashboard/queries/raise': { title: 'My Queries', icon: RaiseQueryIcon },
  '/dashboard/queries/assigned': { title: 'Assigned Queries', icon: AssignedQueriesIcon },
  '/dashboard/queries/escalated': { title: 'Notified Queries', icon: EscalationIcon },
  '/dashboard/queries/closed': { title: 'Closed Queries', icon: ClosedQueriesIcon },
  '/dashboard/admin/users': { title: 'Users', icon: UsersIcon },
  '/dashboard/admin/roles': { title: 'Roles', icon: RolesIcon },
  '/dashboard/projects': { title: 'Projects', icon: ProjectIcon },
  '/dashboard/admin/escalation-matrix': { title: 'Escalation Matrix', icon: EscalationIcon },
  '/dashboard/admin/sla-setup': { title: 'SLA Setup', icon: SLADashboardIcon },
  '/dashboard/admin/templates': { title: 'Templates', icon: QueryDetailsIcon },
  '/dashboard/analytics/sla': { title: 'SLA Dashboard', icon: SLADashboardIcon },
  '/dashboard/analytics/project-reports': { title: 'Project Reports', icon: DashboardIcon },
  '/dashboard/notifications': { title: 'Notifications', icon: NotificationsIcon },
  '/dashboard/documents': { title: 'Documents', icon: QueryDetailsIcon },
  '/dashboard/settings': { title: 'Settings', icon: SettingsIcon },
  '/dashboard/help': { title: 'Help', icon: HelpIconOutline },
};

export const QUICK_SEARCH_OPTIONS = [
  {
    primary: 'All Queries',
    secondary: 'View all queries',
    route: '/dashboard/queries/all',
  },
  {
    primary: 'Assigned Queries',
    secondary: 'View assigned queries',
    route: '/dashboard/queries/assigned',
  },
  {
    primary: 'My Queries',
    secondary: 'Create a new query',
    route: '/dashboard/queries/raise',
  },
];
